import { DataGrid, rows } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import GenericViewsToolbar from "../components/GenericViewsToolbar/GenericViewsToolbar";

const queries = (args = {}) => [
    {
        resource: args.section,
        args: {
            projectId: args.projectId,
            modulePrefix: args.modulePrefix,
            importId: args.importId,
            locale: args.locale || "en",
            filter: args.filter
                ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                : undefined,
            sort: args.sort ? { type: "[SortInput!]", value: parseFilter(args.sort) } : undefined,
            page: parseInt(args.page, 10) || 0,
            pageSize: args.pageSize || 24,
        },
        downloadable: true,
        body: `__typename, hasMore, total, items{...${args.section}}`,
    },
];

const findingsSchemaWithoutFiscalYear = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: App,
    exact,
    queries,
    title: [title],
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                total: "query(0).metadata.total",
                projectModules: "query(1)",
                toolbar: GenericViewsToolbar,
                toolbarProps: {
                    data: "query(0).list",
                },
                showDetailPanel: "query(0).showDetailPanel",
            },
        },
    ],
});

export default findingsSchemaWithoutFiscalYear;
